import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { SketchPicker } from "react-color";
import Modal from "../Modal";

// redux
import { connect } from "react-redux";
import {
  AddTheme,
  EditTheme,
  deleteTheme,
} from "../../Redux/Actions/ThemesListAction";

// style
import Style from "./style";

// img
import Chevron from "../../Assets/down-chevron.svg";
import IphoneFrame from "../../Assets/iphone-frame.svg";
import SvgIcon from "../../Assets/svg-icon.svg";
import PdfIcon from "../../Assets/pdf-icon.svg";
import colorPicker from "../../Assets/color-picker.svg";
import { icon } from "@fortawesome/fontawesome-svg-core";

function Theme(props) {
  const [title, setTitle] = useState("");
  const [header, setHeader] = useState("");
  const [pngSrc, setPngSrc] = useState("");
  const [base64String, setBase64String] = useState("");
  const [ImgName, setSvgName] = useState("");
  const [ImgError, setImgError] = useState("");
  const [SVGError, setSVGError] = useState("");
  const [ShowTextPicker, setShowTextPicker] = useState(false);
  const [ShowCardPicker, setShowCardPicker] = useState(false);
  const [ShowPrimaryPicker, setShowPrimaryPicker] = useState(false);
  const [ShowBackgroundPicker, setShowBackgroundPicker] = useState(false);
  const [ShowIconPicker, setShowIconPicker] = useState(false);
  const [textColor, setTextColor] = useState("");
  const [cardColor, setCardColor] = useState("");
  const [primaryColor, setPrimaryColor] = useState("");
  const [backgroundColor, setBackgroundColor] = useState("");
  const [iconColor, setIconColor] = useState("");
  const [OpenModal, setModal] = useState(false);
  const [Name, setName] = useState(false);

  const initialPath = process.env.REACT_APP_IMAGE_BASE_URL;

  const handleChange = (e, type) => {
    e.preventDefault();
    if (type === "header") {
      if (e.target.files[0].size / 1024 < 2000) {
        if (e.target.files[0].type === "image/png") {
          e.target.files[0] && setHeader(e.target.files[0].name);
          e.target.files[0] && setPngSrc(e.target.files[0]);
          setImgError("");
        } else {
          setImgError("Only png is allowed");
        }
      } else {
        setImgError("File size exceeds");
      }
    }
    if (type === "svg-theme-icon") {
      if (e.target.files[0].size / 1024 < 2000) {
        if (e.target.files[0].type === "image/svg+xml") {
          e.target.files[0] && setSvgName(e.target.files[0].name);
          e.target.files[0] && setBase64String(e.target.files[0]);
          setSVGError("");
        } else {
          setSVGError("Only svg is allowed");
        }
      } else {
        setSVGError("File size exceeds");
      }
    }
  };

  const data = {
    title: title,
    pngSrc: pngSrc,
    icon: base64String,
    textColor: textColor,
    cardColor: cardColor,
    primaryColor: primaryColor,
    backgroundColor: backgroundColor,
    iconColor: iconColor,
  };

  useEffect(() => {
    if (
      props.location.state &&
      props.location.pathname.split("/")[3] === "edit-theme"
    ) {
      setTitle(props.location.state.title);
      setPngSrc("");
      setHeader(
        (initialPath + props.location.state.header_card_image).split("/")[5]
      );
      setPrimaryColor(props.location.state.primary_color);
      setTextColor(props.location.state.text_color);
      setCardColor(props.location.state.card_color);
      setIconColor(props.location.state.icon_color);
      setBackgroundColor(props.location.state.background_color);
      setBase64String("");
      setSvgName('');
    }
  }, []);

  const handleModal = (e, type, name) => {
    e.preventDefault();
    setModal(type);
    setName(name);
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    if (type === "update_yes") {
      handleAdd();
    } else {
      setModal(!OpenModal);
    }
    if (type === "add_yes") {
      handleAdd();
    } else {
      setModal(!OpenModal);
    }
    if (type === "delete_yes") {
      props.deleteTheme(props.location.state.id);
      props.delete_data &&
        props.history.push({
          pathname: "/dashboard/themes",
          back: "yes",
          method: "delete",
        });
    } else if (type === "delete_no") {
      setModal(!OpenModal);
    }
  };

  const handleAdd = () => {
    if (props.location.pathname.split("/")[3] === "edit-theme") {
      const edit_data = {
        title: title,
        text_color: textColor,
        card_color: cardColor,
        primary_color: primaryColor,
        background_color: backgroundColor,
        icon_color: iconColor,
        header_card_image: pngSrc,
        icon: base64String,
        id: props.location.state.id,
      };
      props.EditTheme(edit_data);
      props.edit_data &&
        props.history.push({
          pathname: "/dashboard/themes",
          back: "yes",
          method: "update",
        });
    } else {
      props.AddTheme(data);
      props.add_data &&
        props.history.push({
          pathname: "/dashboard/themes",
          back: "yes",
          method: "add",
        });
    }
  };

  return (
    <>
      <div className="action-wrap">
        <div className="d-flex justify-content-between align-items-center head-wrap mb-4">
          <Link to="/dashboard/themes" className="d-flex head-left">
            <img src={Chevron} alt="Chevron" />
            <span className="text-nowrap text-white f-20 pl-3 text-uppercase">
              {props.location.pathname.split("/")[3] === "edit-theme"
                ? "Edit"
                : "Add"}{" "}
              Theme
            </span>
          </Link>
          {props.location.pathname.split("/")[3] === "edit-theme" && (
            <>
              <div className="head-right">
                <button
                  onClick={(e) => handleModal(e, "delete")}
                  className="text-green form-button"
                >
                  Delete Theme
                </button>
              </div>
            </>
          )}
        </div>
        <div className="action-body-wrap">
          <div className="d-flex mb-4">
            <div className="mobile-screen position-relative">
              <img
                src={IphoneFrame}
                className="iphone-frame"
                alt="IphoneFrame"
              />
              <div
                style={{ width: "269px", marginTop: "-16px", zIndex: "1" }}
                className="position-absolute"
              >
                <div
                  className="mobile-header pt-3 pb-2 pl-3 pr-3"
                  style={{
                    background: cardColor === "" ? "#282828" : cardColor,
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <p
                      className="text-capitalize font-weight-light m-0 f-14"
                      style={{ color: textColor === "" ? "#fff" : textColor }}
                    >
                      Good morning jacob!
                    </p>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.8 13C21.3523 13 21.8 12.5523 21.8 12C21.8 11.4477 21.3523 11 20.8 11C20.2478 11 19.8 11.4477 19.8 12C19.8 12.5523 20.2478 13 20.8 13Z"
                        stroke={iconColor === "" ? "#BDFF00" : iconColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M20.8 5.99998C21.3523 5.99998 21.8 5.55226 21.8 4.99998C21.8 4.44769 21.3523 3.99998 20.8 3.99998C20.2478 3.99998 19.8 4.44769 19.8 4.99998C19.8 5.55226 20.2478 5.99998 20.8 5.99998Z"
                        stroke={iconColor === "" ? "#BDFF00" : iconColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M20.8 20C21.3523 20 21.8 19.5523 21.8 19C21.8 18.4477 21.3523 18 20.8 18C20.2478 18 19.8 18.4477 19.8 19C19.8 19.5523 20.2478 20 20.8 20Z"
                        stroke={iconColor === "" ? "#BDFF00" : iconColor}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="text-center">
                    <p
                      className="font-weight-light mb-1 f-12"
                      style={{ color: textColor === "" ? "#fff" : textColor }}
                    >
                      How much money you have
                    </p>
                    <h6
                      className="font-weight-normal mb-0 f-20"
                      style={{
                        color: textColor.hex === "" ? "#fff" : textColor,
                      }}
                    >
                      $32,537.75
                    </h6>
                  </div>
                </div>
                <div className="mobile-body m-2 mt-3">
                  <div
                    className="mobile-card mt-2 d-flex align-items-center p-3"
                    style={{
                      background: cardColor === "" ? "#282828" : cardColor,
                    }}
                  >
                    <svg
                      width="40"
                      height="48"
                      viewBox="0 0 40 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M39.7654 46.6344L29.3654 36.2344C29.2154 36.0844 29.0123 36 28.7998 36H28.7032C32.7135 31.6002 32.8417 24.8875 28.8584 20.3375L25.7629 16.8H26.3998C26.842 16.8 27.1998 16.4422 27.1998 16V5.6C27.1998 5.1578 26.842 4.8 26.3998 4.8H24.4943L26.3154 1.1578C26.4396 0.9101 26.4263 0.6156 26.2802 0.3797C26.1341 0.1438 25.8772 0 25.5998 0H14.3998C14.1225 0 13.8654 0.1438 13.7193 0.3797C13.5732 0.6156 13.5599 0.9102 13.6841 1.1578L15.0263 3.8422L12.4686 6.4H10.3998H0.799847C0.357647 6.4 -0.000152588 6.7578 -0.000152588 7.2V16C-0.000152588 16.4422 0.357647 16.8 0.799847 16.8H10.3998H14.2369L11.1412 20.3383C9.25995 22.4922 8.22405 25.2453 8.22405 28.0883C8.22405 31.0105 9.34135 33.8418 11.2992 36H8.79975C8.35755 36 7.99975 36.3578 7.99975 36.8V38.4C7.99975 38.6516 8.11855 38.8891 8.32005 39.0398L17.92 46.2398C18.1059 46.3796 18.3473 46.432 18.5731 46.3812L25.3442 44.8765L28.234 47.7656C28.384 47.9156 28.5871 48 28.7996 48H39.1996C39.523 48 39.8152 47.8055 39.9387 47.5062C40.0631 47.207 39.9943 46.8633 39.7654 46.6344ZM9.59985 15.2H1.59985V8H9.59985V15.2ZM24.3053 1.6L22.7053 4.8H20.7647L20.7991 4.0359C20.8093 3.8179 20.7288 3.6046 20.578 3.4468C20.4272 3.289 20.2186 3.2 19.9998 3.2H16.4943L15.6943 1.6H24.3053ZM11.1998 15.2V8H12.7998C13.0123 8 13.2154 7.9156 13.3654 7.7656L16.3311 4.8H19.1631L19.1287 5.5641C19.1185 5.7821 19.199 5.9954 19.3498 6.1532C19.5006 6.311 19.7092 6.4001 19.9279 6.4001H23.1998H25.5998V15.2001H23.9998H15.9998H11.1998V15.2ZM9.82405 28.0883C9.82405 25.632 10.7201 23.2531 12.3459 21.3906L16.3631 16.8H23.6365L27.6545 21.3906C31.2647 25.5156 30.9748 31.7015 26.9943 35.475C26.7873 35.6703 26.5857 35.8461 26.3927 36H19.9997C19.5575 36 19.1997 36.3578 19.1997 36.8V37.6H16.3903C15.1411 37.1305 14.0028 36.4156 13.0059 35.4758C10.9842 33.5594 9.82405 30.8672 9.82405 28.0883ZM27.1549 44.4239L26.1654 43.4344C25.9716 43.2414 25.6927 43.1602 25.4263 43.2188L18.5857 44.7391L9.59985 38V37.6H11.8459L15.7029 39.143C15.7974 39.1805 15.8982 39.2 15.9998 39.2H16.2475H19.3473C19.6786 40.1292 20.5583 40.8 21.5998 40.8H23.9998V39.2H21.5998C21.1584 39.2 20.7998 38.8414 20.7998 38.4V37.6H26.6639H28.4686L30.9107 40.0421L27.1549 44.4239ZM29.1311 46.4L28.289 45.5579L32.0448 41.1762L37.2686 46.4H29.1311Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M19.9999 25.5999C18.6765 25.5999 17.5999 24.5233 17.5999 23.1999C17.5999 21.8765 18.6765 20.7999 19.9999 20.7999C21.3233 20.7999 22.3999 21.8765 22.3999 23.1999H23.9999C23.9999 21.2684 22.6233 19.6525 20.7999 19.2808V17.5999H19.1999V19.2808C17.3765 19.6525 15.9999 21.2684 15.9999 23.1999C15.9999 25.4054 17.7944 27.1999 19.9999 27.1999C21.3233 27.1999 22.3999 28.2765 22.3999 29.5999C22.3999 30.9233 21.3233 31.9999 19.9999 31.9999C18.6765 31.9999 17.5999 30.9233 17.5999 29.5999H15.9999C15.9999 31.5314 17.3765 33.1473 19.1999 33.519V35.1999H20.7999V33.519C22.6233 33.1473 23.9999 31.5314 23.9999 29.5999C23.9999 27.3944 22.2054 25.5999 19.9999 25.5999Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M14.3998 25.6H12.7998V27.2H14.3998V25.6Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M27.1999 25.6H25.5999V27.2H27.1999V25.6Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                    </svg>
                    <p
                      className="mb-0 ml-2 f-14 font-weight-light"
                      style={{ color: textColor === "" ? "#fff" : textColor }}
                    >
                      Bring the Bank to Me!
                    </p>
                  </div>
                  <div
                    className="mobile-card mt-2 d-flex align-items-center p-3"
                    style={{
                      background: cardColor === "" ? "#282828" : cardColor,
                    }}
                  >
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0)">
                        <path
                          d="M40.969 0H33.4921C32.5999 0 32.5999 1.40645 33.4921 1.40645H40.969C43.0651 1.40645 44.7705 3.13414 44.7705 5.2577V21.5324C44.7705 23.6561 43.0652 25.3838 40.969 25.3838H38.667C38.5151 25.3838 38.3674 25.4346 38.2467 25.5284L34.0226 28.8137V26.087C34.0226 25.6986 33.713 25.3838 33.331 25.3838H24.9133C24.2239 25.3838 23.5614 25.1988 22.9772 24.8471V16.9529C22.9772 15.4743 22.2365 14.1679 21.1117 13.395V5.2577C21.1117 3.13414 22.8171 1.40645 24.9133 1.40645H34.605C35.4972 1.40645 35.4972 0 34.605 0H24.9133C22.0543 0 19.7284 2.35862 19.7284 5.2577V12.7769C19.4117 12.7 19.0818 12.6581 18.7422 12.6581H6.08103C3.74598 12.6581 1.84619 14.5847 1.84619 16.9529V24.0099C1.84619 24.917 3.22946 24.917 3.22946 24.0099V16.9529C3.22946 15.3603 4.50862 14.0645 6.08103 14.0645H18.7423C20.3147 14.0645 21.594 15.3603 21.594 16.9529V25.127C21.5857 25.1891 21.586 25.2517 21.594 25.3133V29.7869C21.594 29.8753 21.5887 29.9634 21.5809 30.0509H20.1545C18.5829 30.0509 17.2726 31.2043 17.001 32.7202C16.9381 32.7443 16.8777 32.778 16.8217 32.8218L13.7282 35.2504V33.3785C13.7282 32.9901 13.4186 32.6753 13.0366 32.6753H6.08103C4.50862 32.6753 3.22946 31.3796 3.22946 29.7869V22.6908C3.22946 21.7837 1.84619 21.7837 1.84619 22.6908V29.787C1.84619 32.1552 3.74598 34.0818 6.08103 34.0818H12.345V36.6819C12.345 37.246 13.0187 37.5844 13.4594 37.2386L16.9485 34.4995V42.4108C16.9485 44.204 18.3868 45.6628 20.1546 45.6628H24.399V47.3037C24.399 47.8676 25.0726 48.2064 25.5132 47.8604L28.3126 45.6628H29.1396C30.9075 45.6628 32.3458 44.2039 32.3458 42.4108V41.1622C32.3458 40.2551 30.9625 40.2551 30.9625 41.1622V42.4108C30.9625 43.4285 30.1448 44.2563 29.1396 44.2563H28.0766C27.9236 44.2563 27.775 44.3079 27.654 44.4029L25.7822 45.8722V44.9594C25.7822 44.5711 25.4726 44.2562 25.0905 44.2562H20.1545C19.1495 44.2562 18.3317 43.4283 18.3317 42.4107V33.303C18.3317 32.2853 19.1494 31.4575 20.1545 31.4575H29.1396C30.1447 31.4575 30.9625 32.2854 30.9625 33.303V42.2938C30.9625 43.2008 32.3458 43.2008 32.3458 42.2938V33.3031C32.3458 31.5099 30.9075 30.0511 29.1396 30.0511H22.9693C22.9746 29.9633 22.9772 26.4114 22.9772 26.4114C23.5871 26.6607 24.2409 26.7903 24.9134 26.7903H32.6394V30.2371C32.6394 30.7997 33.3102 31.1385 33.7513 30.7956L38.9013 26.7903H40.9691C43.828 26.7903 46.1539 24.4317 46.1539 21.5325V5.2577C46.1538 2.35862 43.8279 0 40.969 0Z"
                          fill={iconColor === "" ? "#BDFF00" : iconColor}
                        />
                        <path
                          d="M34.6696 5.19606C33.7914 4.96812 32.8965 5.6736 32.8965 6.59623C32.8965 7.60428 32.5352 8.57577 31.8796 9.33122L29.974 11.5237C29.8506 11.3312 29.6374 11.2038 29.3946 11.2038H25.6745C25.2925 11.2038 24.9829 11.5186 24.9829 11.907V20.4174C24.9829 20.8058 25.2925 21.1207 25.6745 21.1207H29.3946C29.6741 21.1207 29.9143 20.9518 30.0234 20.7093C30.7765 21.1772 31.6493 21.4302 32.5372 21.4302H39.1117C40.1163 21.4302 40.945 20.5438 40.8979 19.525C40.877 19.0738 40.8999 13.0155 40.8999 12.8809C40.8999 11.8784 40.0977 11.0627 39.1137 11.0627L35.6949 11.0522L35.8364 10.7114C36.4833 9.15372 36.3768 7.34746 35.5518 5.87941C35.3593 5.53642 35.0458 5.29385 34.6696 5.19606C35.0458 5.29385 34.2932 5.09836 34.6696 5.19606C35.0458 5.29385 33.7915 4.96812 34.6696 5.19606ZM28.703 19.7142H26.3662V12.6102H28.703V19.7142ZM39.1117 12.469C39.335 12.469 39.5167 12.6537 39.5167 12.8808C39.5167 13.0146 39.5153 13.3778 39.5134 13.8701C39.5032 16.5885 39.4964 19.1631 39.5161 19.591C39.5233 19.7454 39.4494 19.8484 39.4048 19.896C39.3275 19.9784 39.2234 20.0236 39.1117 20.0236H32.5372C31.7536 20.0236 30.9866 19.7475 30.3774 19.2462L30.0863 19.0065V13.5184L32.9165 10.2621C33.7956 9.24908 34.2798 7.94717 34.2798 6.59614C34.2798 6.55638 34.3332 6.54607 34.3509 6.57701C34.9634 7.66682 35.0423 9.00773 34.5622 10.1641L34.0163 11.4786C33.9262 11.6955 33.9489 11.9437 34.0765 12.14C34.2042 12.3363 34.42 12.4547 34.6513 12.4554L39.1117 12.469Z"
                          fill={iconColor === "" ? "#BDFF00" : iconColor}
                        />
                        <path
                          d="M7.7683 24.4256C7.38624 24.4256 7.07666 24.7405 7.07666 25.1289C7.07666 25.5172 7.38624 25.8321 7.7683 25.8321H9.80706L9.42619 28.1742C9.36386 28.5573 9.61893 28.9193 9.99573 28.9827C10.034 28.9892 10.0719 28.9923 10.1093 28.9923C10.4417 28.9923 10.7349 28.748 10.7909 28.4036L11.209 25.8322H12.8776L12.4967 28.1743C12.4344 28.5574 12.6894 28.9194 13.0662 28.9828C13.1045 28.9893 13.1424 28.9924 13.1798 28.9924C13.5122 28.9924 13.8054 28.7481 13.8614 28.4037L14.2795 25.8323H17.0547C17.4367 25.8323 17.7463 25.5174 17.7463 25.129C17.7463 24.7407 17.4367 24.4258 17.0547 24.4258H14.5082L14.7872 22.7103H17.0547C17.4367 22.7103 17.7463 22.3955 17.7463 22.0071C17.7463 21.6187 17.4367 21.3039 17.0547 21.3039H15.0159L15.3968 18.9618C15.4591 18.5786 15.204 18.2166 14.8272 18.1532C14.45 18.0897 14.0944 18.3492 14.032 18.7323L13.6139 21.3038H11.9454L12.3263 18.9617C12.3886 18.5785 12.1335 18.2165 11.7567 18.1531C11.379 18.0896 11.024 18.3491 10.9615 18.7322L10.5434 21.3037H7.7683C7.38624 21.3037 7.07666 21.6185 7.07666 22.0069C7.07666 22.3953 7.38624 22.7101 7.7683 22.7101H10.3147L10.0358 24.4256H7.7683ZM11.7168 22.7101H13.3853L13.1063 24.4256H11.4378L11.7168 22.7101Z"
                          fill={iconColor === "" ? "#BDFF00" : iconColor}
                        />
                        <path
                          d="M24.6385 35.086C24.08 34.6185 23.337 34.4341 22.5917 34.6183C21.6366 34.8541 20.6729 35.7619 20.6729 37.2583C20.6729 38.1897 21.0071 38.9981 21.6948 39.7298C22.2565 40.3276 23.0671 40.896 24.3229 41.573C24.4243 41.6276 24.5356 41.6549 24.6469 41.6549C24.7582 41.6549 24.8695 41.6276 24.9709 41.573C27.1618 40.392 28.6209 39.2064 28.6209 37.2583C28.6209 35.7538 27.6229 34.8552 26.6338 34.6322C25.8907 34.4645 25.1703 34.6425 24.6385 35.086ZM27.2375 37.2583C27.2375 38.309 26.5521 39.0861 24.6468 40.1524C22.7416 39.086 22.056 38.3089 22.056 37.2583C22.056 36.4765 22.5013 36.088 22.918 35.985C22.9948 35.9661 23.0771 35.9554 23.1616 35.9554C23.4751 35.9554 23.8197 36.1026 24.0322 36.5214C24.1533 36.7598 24.398 36.9075 24.6606 36.902C24.9242 36.8967 25.162 36.7393 25.2735 36.4963C25.4974 36.0085 25.968 35.9227 26.334 36.0054C26.7709 36.1037 27.2375 36.4847 27.2375 37.2583Z"
                          fill={iconColor === "" ? "#BDFF00" : iconColor}
                        />
                      </g>
                    </svg>
                    <p
                      className="mb-0 ml-2 f-14 font-weight-light"
                      style={{ color: textColor === "" ? "#fff" : textColor }}
                    >
                      Be Entertained
                    </p>
                  </div>
                  <div
                    className="mobile-card mt-2 d-flex align-items-center p-3"
                    style={{
                      background: cardColor === "" ? "#282828" : cardColor,
                    }}
                  >
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.762 27.0383C22.482 26.7184 21.202 27.5183 20.8821 28.7983C20.802 28.9585 20.802 29.1983 20.802 29.3585V31.7583C20.802 32.7981 21.4422 33.6781 22.482 33.998L26.1618 35.1979C26.5618 35.358 26.8016 35.758 26.6419 36.2377C26.6419 36.3177 26.5618 36.4779 26.4817 36.558L25.042 37.9977C24.8017 38.2375 24.4818 38.3176 24.1619 38.1579L3.36335 29.8381C2.16343 29.3585 0.723291 29.9182 0.243636 31.1982C0.0834907 31.438 0.00341797 31.7583 0.00341797 32.0782V34.3179C0.00341797 35.1979 0.563536 36.0779 1.36348 36.4779L24.7217 47.7572C25.2818 47.997 25.8419 48.0771 26.4016 47.917L40.0808 43.9973H48.0002V31.1982H40.0808L23.762 27.0383ZM26.0017 46.3971C25.8419 46.4772 25.6017 46.3971 25.4419 46.3171L2.08336 35.0378C1.76346 34.878 1.60331 34.6378 1.60331 34.3179V32.0782C1.60331 31.5981 1.92321 31.2782 2.40326 31.2782C2.48333 31.2782 2.64347 31.2782 2.72316 31.3583L23.5218 39.6777C24.4018 39.9976 25.4419 39.8374 26.0817 39.1176L27.5215 37.6778C28.4816 36.7177 28.4816 35.1979 27.5215 34.3179C27.2817 34.0781 26.9618 33.8378 26.5618 33.7582L22.882 32.5582C22.562 32.4782 22.3218 32.1583 22.3218 31.838V29.4381C22.3218 28.9585 22.6421 28.6382 23.1218 28.6382H23.2819L39.1207 32.6379V42.6372L26.0017 46.3971ZM46.4003 42.3974H40.8007V32.7981H46.4003V42.3974Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M42.4004 34.3975H44.0003V37.5972H42.4004V34.3975Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M23.2015 20.7989V22.3988H24.8014V20.7989C25.6814 20.7989 26.4012 20.079 26.4012 19.199V16.7991C26.4012 15.9191 25.6814 15.1992 24.8014 15.1992H23.2015V12.7994H24.8014V13.5993H26.4012V12.7994C26.4012 11.9194 25.6814 11.1995 24.8014 11.1995V9.59961H23.2015V11.1995C22.3214 11.1995 21.6016 11.9194 21.6016 12.7994V15.1992C21.6016 16.0793 22.3214 16.7991 23.2015 16.7991H24.8014V19.199H23.2015V18.399H21.6016V19.199C21.6016 20.079 22.3214 20.7989 23.2015 20.7989Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M23.2017 0H24.8015V3.99973H23.2017V0Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M18.4019 0.799805H20.0018V4.79953H18.4019V0.799805Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M14.4019 2.39941H16.0017V5.5992H14.4019V2.39941Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M32.001 2.39941H33.6009V6.39915H32.001V2.39941Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M27.2012 0.799805H28.8011V5.59948H27.2012V0.799805Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M12.0023 16.7986V15.9986C12.0023 15.1186 11.2824 14.3987 10.4024 14.3987V12.7988H8.80253V14.3987C7.92251 14.3987 7.20264 15.1186 7.20264 15.9986V18.3985C7.20264 19.2785 7.92251 19.9983 8.80253 19.9983H10.4024V22.3982H8.80253V21.5982H7.20264V22.3982C7.20264 23.2782 7.92251 23.9981 8.80253 23.9981V25.598H10.4024V23.9981C11.2824 23.9981 12.0023 23.2782 12.0023 22.3982V19.9983C12.0023 19.1183 11.2824 18.3985 10.4024 18.3985H8.80253V15.9986H10.4024V16.7986H12.0023Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M6.40283 5.59961H8.00272V7.99945H6.40283V5.59961Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M10.4023 4H12.0022V7.99973H10.4023V4Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M36.8008 4H38.4007V7.99973H36.8008V4Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M40.8003 4.7998H42.4002V7.99959H40.8003V4.7998Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M24.0012 25.5981C29.2809 25.5981 33.6005 21.2785 33.6005 15.9988C33.6005 10.719 29.2809 6.39941 24.0012 6.39941C18.7215 6.39941 14.4019 10.719 14.4019 15.9988C14.4019 21.2785 18.7215 25.5981 24.0012 25.5981ZM24.0012 7.99931C28.4009 7.99931 32.0006 11.5991 32.0006 15.9988C32.0006 20.3985 28.4009 23.9982 24.0012 23.9982C19.6015 23.9982 16.0017 20.3985 16.0017 15.9988C16.0017 11.5991 19.6015 7.99931 24.0012 7.99931Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M9.60265 28.7975C12.4825 28.7975 15.2023 27.5175 17.0424 25.2778L15.8425 24.2377C13.0426 27.6777 8.00275 28.1577 4.56314 25.2778C1.12314 22.398 0.643487 17.4381 3.52298 13.9985C5.68299 11.3588 9.36282 10.3988 12.5626 11.6788L13.1223 10.1589C8.1629 8.23875 2.64335 10.6386 0.723169 15.5984C-1.19662 20.5582 1.20321 26.0778 6.16304 27.9976C7.20281 28.5577 8.40273 28.7975 9.60265 28.7975Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M36.0005 21.5982V22.3982C36.0005 23.2782 36.7204 23.9981 37.6004 23.9981V25.598H39.2003V23.9981C40.0803 23.9981 40.8002 23.2782 40.8002 22.3982V19.9983C40.8002 19.1183 40.0803 18.3985 39.2003 18.3985H37.6004V15.9986H39.2003V16.7986H40.8002V15.9986C40.8002 15.1186 40.0803 14.3987 39.2003 14.3987V12.7988H37.6004V14.3987C36.7204 14.3987 36.0005 15.1186 36.0005 15.9986V18.3985C36.0005 19.2785 36.7204 19.9983 37.6004 19.9983H39.2003V22.3982H37.6004V21.5982H36.0005Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M38.4007 11.1995C42.8004 11.1995 46.4001 14.7993 46.4001 19.199C46.4001 23.5987 42.8004 27.1984 38.4007 27.1984C36.161 27.1984 34.0811 26.3184 32.5612 24.7185L31.3613 25.8384C33.201 27.7585 35.681 28.8784 38.3206 28.8784C43.6003 28.8784 47.92 24.5588 47.92 19.279C47.92 13.9993 43.6003 9.67969 38.3206 9.67969C36.8008 9.67969 35.281 9.99959 34.001 10.7195L34.7209 12.1596C35.9208 11.5194 37.1207 11.1995 38.4007 11.1995Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                    </svg>
                    <p
                      className="mb-0 ml-2 f-14 font-weight-light"
                      style={{ color: textColor === "" ? "#fff" : textColor }}
                    >
                      Change my Life with Better Products
                    </p>
                  </div>
                  <div
                    className="mobile-card mt-2 d-flex align-items-center p-3"
                    style={{
                      background: cardColor === "" ? "#282828" : cardColor,
                    }}
                  >
                    <svg
                      width="42"
                      height="46"
                      viewBox="0 0 42 46"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.4092 45.5C24.1548 45.4992 24.8697 45.2026 25.397 44.6753C25.9242 44.148 26.2208 43.4332 26.2217 42.6875V32H39.5342C39.9816 31.9995 40.4105 31.8215 40.7268 31.5052C41.0432 31.1888 41.2212 30.7599 41.2217 30.3125V15.6875C41.2212 15.2401 41.0432 14.8112 40.7268 14.4948C40.4105 14.1785 39.9816 14.0005 39.5342 14H26.2217V3.3125C26.2208 2.56684 25.9242 1.85196 25.397 1.32469C24.8697 0.797431 24.1548 0.500844 23.4092 0.5H3.53418C2.78852 0.500844 2.07364 0.797431 1.54637 1.32469C1.01911 1.85196 0.722523 2.56684 0.72168 3.3125V42.6875C0.722523 43.4332 1.01911 44.148 1.54637 44.6753C2.07364 45.2026 2.78852 45.4992 3.53418 45.5H23.4092ZM2.22168 6.5H24.7217V38H2.22168V6.5ZM26.2217 20.8782C26.561 20.7585 26.9241 20.7219 27.2805 20.7715C27.6369 20.8211 27.9762 20.9555 28.2699 21.1633C28.5636 21.3712 28.8032 21.6464 28.9685 21.966C29.1339 22.2856 29.2202 22.6402 29.2202 23C29.2202 23.3598 29.1339 23.7144 28.9685 24.034C28.8032 24.3536 28.5636 24.6288 28.2699 24.8367C27.9762 25.0445 27.6369 25.1789 27.2805 25.2285C26.9241 25.2781 26.561 25.2415 26.2217 25.1218V20.8782ZM26.2217 26.6739C26.7666 26.7854 27.3295 26.7743 27.8696 26.6413C28.4097 26.5084 28.9135 26.257 29.3444 25.9053C29.7754 25.5536 30.1227 25.1105 30.3612 24.608C30.5997 24.1055 30.7234 23.5562 30.7234 23C30.7234 22.4438 30.5997 21.8945 30.3612 21.392C30.1227 20.8895 29.7754 20.4464 29.3444 20.0947C28.9135 19.743 28.4097 19.4916 27.8696 19.3587C27.3295 19.2257 26.7666 19.2146 26.2217 19.3261V18.5H34.5666C34.7016 19.0185 34.9725 19.4915 35.3513 19.8703C35.7302 20.2492 36.2032 20.5201 36.7217 20.6551V25.3449C36.2031 25.4798 35.73 25.7507 35.3511 26.1296C34.9721 26.5084 34.7012 26.9815 34.5661 27.5H26.2217V26.6739ZM39.5342 15.5C39.5839 15.5 39.6316 15.5198 39.6668 15.5549C39.7019 15.5901 39.7217 15.6378 39.7217 15.6875V30.3125C39.7217 30.3622 39.7019 30.4099 39.6668 30.4451C39.6316 30.4802 39.5839 30.5 39.5342 30.5H26.2217V29H35.2217C35.4206 29 35.6114 28.921 35.752 28.7803C35.8927 28.6397 35.9717 28.4489 35.9717 28.25C35.9721 27.8523 36.1303 27.4711 36.4115 27.1899C36.6927 26.9087 37.074 26.7505 37.4717 26.75C37.6706 26.75 37.8614 26.671 38.002 26.5303C38.1427 26.3897 38.2217 26.1989 38.2217 26V20C38.2217 19.8011 38.1427 19.6103 38.002 19.4697C37.8614 19.329 37.6706 19.25 37.4717 19.25C37.074 19.2495 36.6927 19.0913 36.4115 18.8101C36.1303 18.5289 35.9721 18.1477 35.9717 17.75C35.9717 17.5511 35.8927 17.3603 35.752 17.2197C35.6114 17.079 35.4206 17 35.2217 17H26.2217V15.5H39.5342ZM3.53418 2H23.4092C23.7572 2.00037 24.0908 2.13877 24.3368 2.38483C24.5829 2.63089 24.7213 2.96452 24.7217 3.3125V5H2.22168V3.3125C2.22205 2.9646 2.36039 2.63105 2.60635 2.385C2.85231 2.13895 3.18581 2.0005 3.53371 2H3.53418ZM2.22168 42.6875V39.5H24.7217V42.6875C24.7213 43.0355 24.5829 43.3691 24.3368 43.6152C24.0908 43.8612 23.7572 43.9996 23.4092 44H3.53418C3.1862 43.9996 2.85257 43.8612 2.60651 43.6152C2.36045 43.3691 2.22205 43.0355 2.22168 42.6875Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M22.8872 17.126L13.8872 11.126C13.764 11.0438 13.6192 11 13.4711 11C13.3231 11 13.1783 11.0438 13.0551 11.126L4.05513 17.126C3.95241 17.1944 3.86818 17.2872 3.80993 17.3961C3.75167 17.5049 3.72119 17.6265 3.72119 17.75V20C3.72119 20.1989 3.80021 20.3896 3.94086 20.5303C4.08151 20.6709 4.27228 20.75 4.47119 20.75H5.22119V25.25C5.02228 25.25 4.83151 25.329 4.69086 25.4696C4.55021 25.6103 4.47119 25.801 4.47119 26V28.25C4.27228 28.25 4.08151 28.329 3.94086 28.4696C3.80021 28.6103 3.72119 28.801 3.72119 29V32C3.72119 32.1989 3.80021 32.3896 3.94086 32.5303C4.08151 32.6709 4.27228 32.75 4.47119 32.75H22.4712C22.6701 32.75 22.8609 32.6709 23.0015 32.5303C23.1422 32.3896 23.2212 32.1989 23.2212 32V29C23.2212 28.801 23.1422 28.6103 23.0015 28.4696C22.8609 28.329 22.6701 28.25 22.4712 28.25V26C22.4712 25.801 22.3922 25.6103 22.2515 25.4696C22.1109 25.329 21.9201 25.25 21.7212 25.25V20.75H22.4712C22.6701 20.75 22.8609 20.6709 23.0015 20.5303C23.1422 20.3896 23.2212 20.1989 23.2212 20V17.75C23.2212 17.6265 23.1907 17.5049 23.1324 17.3961C23.0741 17.2872 22.9899 17.1944 22.8872 17.126ZM6.72166 20.75H8.22166V25.25H6.72166V20.75ZM15.7217 25.25V20.75H17.2217V25.25H15.7217ZM9.72166 25.25V20.75H11.2217V25.25H9.72166ZM12.7217 20.75H14.2217V25.25H12.7217V20.75ZM9.19872 19.25L13.4717 16.4014L17.744 19.25H9.19872ZM21.7217 31.25H5.22166V29.75H21.7217V31.25ZM5.97166 28.25V26.75H20.9717V28.25H5.97166ZM20.2217 25.25H18.7217V20.75H20.2217V25.25ZM21.7217 19.25H20.4483L13.8872 14.876C13.764 14.7938 13.6192 14.75 13.4711 14.75C13.3231 14.75 13.1783 14.7938 13.0551 14.876L6.49413 19.25H5.22166V18.1513L13.4717 12.6514L21.7217 18.1513V19.25Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M11.9717 42.5H15.7217C15.9206 42.5 16.1114 42.421 16.252 42.2803C16.3927 42.1397 16.4717 41.9489 16.4717 41.75C16.4717 41.5511 16.3927 41.3603 16.252 41.2197C16.1114 41.079 15.9206 41 15.7217 41H11.9717C11.7728 41 11.582 41.079 11.4414 41.2197C11.3007 41.3603 11.2217 41.5511 11.2217 41.75C11.2217 41.9489 11.3007 42.1397 11.4414 42.2803C11.582 42.421 11.7728 42.5 11.9717 42.5Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M28.4717 33.5C28.2728 33.5 28.082 33.579 27.9413 33.7197C27.8007 33.8603 27.7217 34.0511 27.7217 34.25C27.7217 34.4489 27.8007 34.6397 27.9413 34.7803C28.082 34.921 28.2728 35 28.4717 35H29.2217C29.4206 35 29.6114 34.921 29.752 34.7803C29.8927 34.6397 29.9717 34.4489 29.9717 34.25C29.9717 34.0511 29.8927 33.8603 29.752 33.7197C29.6114 33.579 29.4206 33.5 29.2217 33.5H28.4717Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M32.2217 33.5C32.0228 33.5 31.832 33.579 31.6913 33.7197C31.5507 33.8603 31.4717 34.0511 31.4717 34.25C31.4717 34.4489 31.5507 34.6397 31.6913 34.7803C31.832 34.921 32.0228 35 32.2217 35H35.9717C36.1706 35 36.3614 34.921 36.502 34.7803C36.6427 34.6397 36.7217 34.4489 36.7217 34.25C36.7217 34.0511 36.6427 33.8603 36.502 33.7197C36.3614 33.579 36.1706 33.5 35.9717 33.5H32.2217Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M13.4712 36.125C13.989 36.125 14.4087 35.7053 14.4087 35.1875C14.4087 34.6697 13.989 34.25 13.4712 34.25C12.9534 34.25 12.5337 34.6697 12.5337 35.1875C12.5337 35.7053 12.9534 36.125 13.4712 36.125Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M10.2837 36.125C10.8015 36.125 11.2212 35.7053 11.2212 35.1875C11.2212 34.6697 10.8015 34.25 10.2837 34.25C9.76592 34.25 9.34619 34.6697 9.34619 35.1875C9.34619 35.7053 9.76592 36.125 10.2837 36.125Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M16.6587 36.125C17.1765 36.125 17.5962 35.7053 17.5962 35.1875C17.5962 34.6697 17.1765 34.25 16.6587 34.25C16.1409 34.25 15.7212 34.6697 15.7212 35.1875C15.7212 35.7053 16.1409 36.125 16.6587 36.125Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                    </svg>
                    <p
                      className="mb-0 ml-2 f-14 font-weight-light"
                      style={{ color: textColor === "" ? "#fff" : textColor }}
                    >
                      Go To Online Banking
                    </p>
                  </div>
                  <div
                    className="mobile-card mt-2 d-flex align-items-center p-3"
                    style={{
                      background: cardColor === "" ? "#282828" : cardColor,
                    }}
                  >
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.9918 14.5925H26.4177C26.6599 14.5925 26.8868 14.474 27.0253 14.2753C27.1637 14.0766 27.1963 13.8227 27.1125 13.5955L24.1103 5.44733C24.003 5.1563 23.7257 4.96296 23.4155 4.96289H8.98958C8.74764 4.96343 8.52121 5.08209 8.38308 5.28072C8.24495 5.47936 8.21253 5.73293 8.29625 5.95993L11.2985 14.1081C11.4056 14.3986 11.6821 14.5918 11.9918 14.5925ZM22.8992 6.44437L25.3547 13.111H12.5081L10.0525 6.44437H22.8992Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M4.74074 13.2681V40.6452C4.73886 41.2351 4.97336 41.8012 5.39185 42.217L9.40148 46.2267C9.47038 46.2956 9.55219 46.3502 9.64222 46.3874C9.73216 46.4248 9.82854 46.4441 9.92593 46.4444H30.6667C31.0758 46.4444 31.4074 46.1128 31.4074 45.7037V43.4815H41.037C42.6734 43.4815 44 42.1549 44 40.5185V22C44 20.3636 42.6734 19.037 41.037 19.037H31.4074V16.8148C31.4061 16.8066 31.4044 16.7984 31.4022 16.7904C31.4016 16.7114 31.3878 16.633 31.3615 16.5585L26.1763 2.48444C26.069 2.19341 25.7917 2.00007 25.4815 2H4.74074C4.65216 2.00168 4.5646 2.01925 4.48222 2.05185C4.46593 2.05852 4.45037 2.06296 4.43482 2.07407C4.36002 2.10784 4.29141 2.15391 4.23185 2.21037C4.22222 2.22222 4.21037 2.23111 4.19852 2.2437C4.17502 2.26678 4.15324 2.29154 4.13333 2.31778C4.11017 2.35341 4.09033 2.3911 4.07408 2.43037C4.06815 2.44444 4.06074 2.45037 4.0563 2.46222C4.02493 2.54262 4.00764 2.62781 4.00519 2.71407C4.00519 2.72296 4 2.73111 4 2.74074V9.06519C3.99948 9.86865 4.14013 10.666 4.41556 11.4207C4.6313 12.0127 4.74137 12.6381 4.74074 13.2681ZM6.22222 40.6452V13.2681C6.22275 12.4647 6.08209 11.6674 5.80667 10.9126C5.59093 10.3206 5.48086 9.69528 5.48148 9.06519L5.48148 6.89407L9.18519 16.9474V43.9156L6.43926 41.1696C6.30015 41.0306 6.22207 40.8419 6.22222 40.6452ZM35.1111 20.5185V42H28.4444C27.6262 42 26.963 41.3367 26.963 40.5185V22C26.963 21.1818 27.6262 20.5185 28.4444 20.5185H35.1111ZM42.5185 22V40.5185C42.5185 41.3367 41.8552 42 41.037 42H40.2963V20.5185H41.037C41.8552 20.5185 42.5185 21.1818 42.5185 22ZM38.8148 20.5185V42H36.5926V20.5185H38.8148ZM28.4444 19.037C26.808 19.037 25.4815 20.3636 25.4815 22V40.5185C25.4815 42.1549 26.808 43.4815 28.4444 43.4815H29.9259V44.963H10.6667V17.5556H29.9259V19.037H28.4444ZM24.963 3.48148L29.6015 16.0741H10.4444L5.8037 3.48148H24.963Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M13.4127 9.93083L14.8942 8.44935C15.0868 8.26337 15.164 7.98796 15.0962 7.72897C15.0284 7.46999 14.8262 7.26773 14.5672 7.19994C14.3082 7.13215 14.0328 7.20938 13.8468 7.40194L12.3653 8.88342C12.1728 9.06941 12.0955 9.34482 12.1633 9.6038C12.2311 9.86279 12.4334 10.065 12.6923 10.1328C12.9513 10.2006 13.2267 10.1234 13.4127 9.93083Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M13.8468 12.1531C14.136 12.4422 14.6049 12.4422 14.8942 12.1531L18.5979 8.44935C18.7904 8.26337 18.8677 7.98796 18.7999 7.72897C18.7321 7.46999 18.5298 7.26773 18.2708 7.19994C18.0119 7.13215 17.7364 7.20938 17.5505 7.40194L13.8468 11.1056C13.5576 11.3949 13.5576 11.8638 13.8468 12.1531Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M16.8097 12.5329C17.0989 12.8221 17.5678 12.8221 17.8571 12.5329L21.5608 8.82923C21.7533 8.64325 21.8305 8.36784 21.7628 8.10885C21.695 7.84987 21.4927 7.64761 21.2337 7.57982C20.9747 7.51203 20.6993 7.58926 20.5134 7.78182L16.8097 11.4855C16.5205 11.7748 16.5205 12.2437 16.8097 12.5329Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M22.5187 19.5928H18.0743C17.2561 19.5928 16.5928 20.2561 16.5928 21.0743V21.6297C16.5928 22.4479 17.2561 23.1112 18.0743 23.1112H22.5187C23.3369 23.1112 24.0002 22.4479 24.0002 21.6297V21.0743C24.0002 20.2561 23.3369 19.5928 22.5187 19.5928ZM18.0743 21.6297V21.0743H22.5187V21.6297H18.0743Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M12.8892 19.7773C12.4801 19.7773 12.1484 20.1704 12.1484 20.6553V42.6031C12.1484 43.088 12.4801 43.481 12.8892 43.481C13.2983 43.481 13.6299 43.088 13.6299 42.6031V20.6553C13.6299 20.1704 13.2983 19.7773 12.8892 19.7773Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M29.2281 36.0739C28.4725 36.8099 28.238 37.9303 28.6353 38.9075C29.0325 39.8847 29.9822 40.5238 31.037 40.5238C32.0919 40.5238 33.0415 39.8847 33.4388 38.9075C33.836 37.9303 33.6016 36.8099 32.8459 36.0739C33.6016 35.3379 33.836 34.2175 33.4388 33.2403C33.0415 32.2631 32.0919 31.624 31.037 31.624C29.9822 31.624 29.0325 32.2631 28.6353 33.2403C28.238 34.2175 28.4725 35.3379 29.2281 36.0739ZM32.1481 37.9257C32.1481 38.5394 31.6507 39.0368 31.037 39.0368C30.4234 39.0368 29.9259 38.5394 29.9259 37.9257C29.9259 37.3121 30.4234 36.8146 31.037 36.8146C31.6507 36.8146 32.1481 37.3121 32.1481 37.9257ZM31.037 33.1109C31.6507 33.1109 32.1481 33.6084 32.1481 34.222C32.1481 34.8357 31.6507 35.3331 31.037 35.3331C30.4234 35.3331 29.9259 34.8357 29.9259 34.222C29.9259 33.6084 30.4234 33.1109 31.037 33.1109Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                    </svg>
                    <p
                      className="mb-0 ml-2 f-14 font-weight-light"
                      style={{ color: textColor === "" ? "#fff" : textColor }}
                    >
                      Find Closest ATM
                    </p>
                  </div>
                </div>
                <div
                  className="mobile-nav mt-3 d-flex justify-content-between align-items-center"
                  style={{
                    background: cardColor === "" ? "#282828" : cardColor,
                  }}
                >
                  <div className="d-flex align-items-center">
                    <svg
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.25 9.75002L13 2.16669L22.75 9.75002V21.6667C22.75 22.2413 22.5217 22.7924 22.1154 23.1988C21.7091 23.6051 21.158 23.8334 20.5833 23.8334H5.41667C4.84203 23.8334 4.29093 23.6051 3.8846 23.1988C3.47827 22.7924 3.25 22.2413 3.25 21.6667V9.75002Z"
                        stroke={iconColor === "" ? "#BDFF00" : iconColor}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9.75 23.8333V13H16.25V23.8333"
                        stroke={iconColor === "" ? "#BDFF00" : iconColor}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p
                      className="pl-2 m-0 f-12 text-green"
                      style={{
                        color: iconColor === "" ? "#BDFF00" : iconColor,
                      }}
                    >
                      Home
                    </p>
                  </div>
                  <svg
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path
                        d="M20.8075 15.0968H5.19231L3.51489 18.4516H5.03219V26H20.9677V18.4516H22.485L20.8075 15.0968ZM20.2891 15.9355L21.1278 17.6129H14.5172L13.6785 15.9355H20.2891ZM5.71077 15.9355H12.3213L11.4826 17.6129H4.87206L5.71077 15.9355ZM20.129 25.1613H13.4193V22.2258H12.5806V25.1613H5.8709V18.4516H12.0011L12.5806 17.2925V22.9678H13.4193V17.2925L13.9988 18.4516H20.129V25.1613Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M11.0634 6.82047L13.0001 6.32678L14.9367 6.82006L15.0885 4.74048L16.1172 2.98321L14.2977 2.19569L13.0001 0.59137L11.7021 2.19569L9.88257 2.98321L10.9113 4.74048L11.0634 6.82047ZM12.2246 2.88308L13.0001 1.92479L13.7755 2.88349L14.9152 3.37717L14.2665 4.48535L14.1734 5.76061L13.0001 5.46166L11.8268 5.7602L11.7336 4.48494L11.0849 3.37656L12.2246 2.88308Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M4.60456 7.67639L5.21394 6.63599L4.13443 6.16831L3.35489 5.20428L2.57536 6.1679L1.49585 6.63558L2.10522 7.67598L2.19532 8.91684L3.35489 8.62198L4.51488 8.91725L4.60456 7.67639ZM3.78264 7.42044L3.7507 7.85699L3.35489 7.75645L2.9595 7.85699L2.92714 7.42044L2.69781 7.02831L3.09751 6.85529L3.35489 6.5377L3.61187 6.8557L4.01157 7.02893L3.78264 7.42044Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M23.8948 7.67639L24.5042 6.63599L23.4247 6.16831L22.6452 5.20428L21.8656 6.1679L20.7861 6.63558L21.3955 7.67598L21.4856 8.91684L22.6452 8.62198L23.8052 8.91725L23.8948 7.67639ZM23.0729 7.42044L23.041 7.85699L22.6452 7.75645L22.2498 7.85699L22.2178 7.42044L21.9885 7.02831L22.3882 6.85529L22.6452 6.5377L22.9022 6.8557L23.3019 7.02893L23.0729 7.42044Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M5.21881 9.9941C6.01739 10.5267 6.72689 11.1766 7.32624 11.9265L8.98727 14.0019L8.64368 11.2542C8.46431 9.81964 7.69809 8.49913 6.54158 7.63196L6.13984 7.33075L4.91064 9.78852L5.21881 9.9941ZM6.42753 8.6312C7.13662 9.30221 7.61761 10.1954 7.78245 11.1617C7.25273 10.5396 6.65175 9.9853 5.98934 9.50759L6.42753 8.6312Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M17.3563 11.2542L17.0127 14.0019L18.6737 11.926C19.2735 11.1762 19.9826 10.5263 20.7812 9.99368L21.0889 9.78809L19.8597 7.33032L19.458 7.63235C18.3019 8.49952 17.5353 9.81963 17.3563 11.2542ZM20.0106 9.50757C19.3482 9.98528 18.7468 10.5392 18.2175 11.1616C18.3828 10.1954 18.8633 9.30219 19.5724 8.63118L20.0106 9.50757Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M14.6775 14.2581H15.5162V12.501C15.5162 10.4867 16.2261 8.52592 17.5161 6.97811L16.8715 6.44122C15.4566 8.13932 14.6775 10.2914 14.6775 12.501V14.2581Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M17.6128 5.03229H18.4515V5.871H17.6128V5.03229Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M18.8708 3.35486H19.7096V4.19357H18.8708V3.35486Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M10.4839 14.2581H11.3226V12.501C11.3226 10.291 10.5435 8.13932 9.12897 6.44122L8.48438 6.97811C9.77397 8.52592 10.4839 10.4867 10.4839 12.501V14.2581Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M7.54834 5.03229H8.38705V5.871H7.54834V5.03229Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M6.29028 3.35486H7.12899V4.19357H6.29028V3.35486Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M12.5806 7.12903H13.4193V7.96774H12.5806V7.12903Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M12.5806 8.80646H13.4193V14.2581H12.5806V8.80646Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                    </g>
                  </svg>
                  <svg
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path
                        d="M8.23047 22.5011C8.09697 22.5011 7.96605 22.4474 7.87143 22.3523C7.84822 22.3289 7.8268 22.303 7.80855 22.2752C7.7903 22.2476 7.77443 22.2182 7.76173 22.1877C7.74904 22.1568 7.73952 22.1252 7.73277 22.0929C7.72623 22.0598 7.72266 22.0268 7.72266 21.9933C7.72266 21.8596 7.77701 21.7287 7.87143 21.6343C7.98926 21.5164 8.16461 21.4621 8.33005 21.4956C8.36258 21.5022 8.39452 21.5119 8.42506 21.5246C8.45541 21.5373 8.48497 21.5529 8.51294 21.5712C8.54031 21.5894 8.5663 21.6109 8.5901 21.6343C8.68452 21.7287 8.73888 21.8596 8.73888 21.9933C8.73888 22.0268 8.73531 22.0598 8.72876 22.0929C8.72202 22.1252 8.71249 22.1568 8.6998 22.1877C8.6871 22.2182 8.67123 22.2476 8.65299 22.2752C8.63434 22.303 8.61351 22.3289 8.5901 22.3523C8.5663 22.3761 8.54031 22.397 8.51294 22.4158C8.48497 22.4341 8.45541 22.4497 8.42506 22.4624C8.39452 22.4751 8.36258 22.4849 8.33005 22.4914C8.29712 22.4981 8.26399 22.5011 8.23047 22.5011Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M24.5331 16.365C23.9658 15.3772 22.699 15.0332 21.7021 15.5926L17.9548 17.4122C17.6184 16.6029 16.8198 16.0324 15.8902 16.0324H11.8216C11.1158 15.0342 9.95421 14.425 8.72337 14.425C8.68013 14.425 8.63688 14.4258 8.59424 14.4272C7.04284 14.4794 5.70667 15.5454 5.27265 17.0482H5.08857V16.7403C5.08857 16.4599 4.86124 16.2325 4.58076 16.2325H1.56762C1.28714 16.2325 1.05981 16.4599 1.05981 16.7403V22.9019C1.05981 23.1824 1.28714 23.4097 1.56762 23.4097H4.58076C4.86104 23.4097 5.08857 23.1824 5.08857 22.9019V22.5284C7.03233 22.8965 13.0308 24 15.0642 24C16.161 24 17.9242 23.2012 20.4546 21.5582C22.2686 20.3803 23.8124 19.1856 23.8277 19.1737C23.8446 19.1606 23.8604 19.1465 23.8755 19.1314C24.7678 18.2392 25.0139 17.2053 24.5331 16.365ZM4.07275 22.3941H2.07543V17.2482H4.07275V22.3941ZM23.1791 18.3913C21.5015 19.689 16.8531 22.9844 15.0642 22.9844C13.0737 22.9844 6.76335 21.8123 5.08857 21.4943V18.0638H5.67195C5.90939 18.0638 6.11529 17.8992 6.16726 17.6673L6.20773 17.4874C6.46997 16.3224 7.46535 15.4813 8.62855 15.4423C8.66009 15.4413 8.69163 15.4407 8.72337 15.4407C9.69694 15.4407 10.6114 15.9614 11.1099 16.7997C11.2013 16.9538 11.3672 17.048 11.5463 17.048H15.8902C16.5623 17.048 17.109 17.5949 17.109 18.2669C17.109 18.939 16.5623 19.4857 15.8902 19.4857H10.1266C9.8461 19.4857 9.61878 19.713 9.61878 19.9935C9.61878 20.274 9.8461 20.5013 10.1266 20.5013H15.8902C17.0562 20.5013 18.0165 19.6035 18.1161 18.4629L22.1603 16.4993C22.1706 16.4944 22.1807 16.4888 22.1908 16.4833C22.705 16.1887 23.3606 16.3629 23.652 16.8703C23.9872 17.456 23.4508 18.1138 23.1791 18.3913Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M8.42604 10.7222C8.15913 10.7222 7.89222 10.6978 7.63281 10.6495C7.49949 10.6249 7.39248 10.5251 7.35867 10.3938L7.28043 10.091C7.05441 10.0214 6.83562 9.931 6.62624 9.82112L6.37759 9.98034C6.25995 10.0557 6.10878 10.0537 5.99318 9.97516C5.53747 9.66558 5.14937 9.27747 4.83979 8.82174C4.76128 8.70614 4.75923 8.55496 4.83461 8.43732L4.99383 8.18867C4.88396 7.97927 4.79372 7.76048 4.72406 7.53446L4.4213 7.45621C4.29003 7.42226 4.19024 7.31539 4.16543 7.18206C4.11731 6.92264 4.09277 6.65573 4.09277 6.38867C4.09277 6.12162 4.11731 5.8547 4.16543 5.59528C4.19024 5.46195 4.29003 5.35508 4.4213 5.32113L4.72406 5.24302C4.79372 5.017 4.88396 4.79807 4.99383 4.58868L4.83461 4.34016C4.75923 4.22252 4.76128 4.07133 4.83979 3.95573C5.14937 3.50001 5.53747 3.1119 5.99318 2.80218C6.10878 2.72366 6.26009 2.72175 6.37759 2.797L6.62624 2.95636C6.83562 2.84648 7.05441 2.7561 7.28043 2.68644L7.35867 2.38367C7.39261 2.25239 7.49949 2.1526 7.63281 2.12793C8.15163 2.03141 8.70058 2.03141 9.21941 2.12793C9.35273 2.1526 9.4596 2.25239 9.49354 2.38367L9.57179 2.68644C9.7978 2.7561 10.0166 2.84635 10.226 2.95636L10.4745 2.797C10.5921 2.72161 10.7433 2.72366 10.8589 2.80218C11.3147 3.1119 11.7028 3.49987 12.0124 3.95573C12.0909 4.0712 12.093 4.22252 12.0176 4.34016L11.8584 4.58868C11.9683 4.79807 12.0585 5.017 12.1282 5.24288L12.4309 5.32113C12.5622 5.35508 12.662 5.46195 12.6868 5.59528C12.7349 5.8547 12.7594 6.12162 12.7594 6.38867C12.7594 6.65573 12.7349 6.92251 12.6868 7.18206C12.662 7.31539 12.5622 7.42226 12.4309 7.45621L12.1282 7.53432C12.0585 7.76034 11.9681 7.97914 11.8582 8.18867L12.0176 8.43718C12.093 8.55483 12.0909 8.70614 12.0124 8.82161C11.7027 9.27733 11.3147 9.66544 10.8589 9.97516C10.7434 10.0537 10.5921 10.0557 10.4745 9.98034L10.226 9.82098C10.0166 9.931 9.79767 10.0212 9.57179 10.0909L9.49354 10.3937C9.4596 10.525 9.35273 10.6247 9.21941 10.6494C8.95999 10.6978 8.69308 10.7222 8.42604 10.7222ZM7.97687 9.9967C8.27364 10.0332 8.57858 10.0332 8.87534 9.9967L8.94636 9.72174C8.9784 9.59783 9.07559 9.50145 9.19978 9.4705C9.50227 9.39498 9.79112 9.27542 10.0584 9.11497C10.1721 9.04681 10.3146 9.04899 10.4262 9.12043L10.6509 9.26438C10.8949 9.07558 11.1127 8.8576 11.3017 8.61358L11.1577 8.38892C11.0861 8.27727 11.0841 8.13482 11.1523 8.02113C11.3126 7.7538 11.4321 7.46493 11.5076 7.16243C11.5387 7.03824 11.6351 6.94105 11.759 6.90901L12.034 6.83799C12.0522 6.68967 12.0615 6.53931 12.0615 6.38881C12.0615 6.23831 12.0522 6.08794 12.034 5.93963L11.759 5.8686C11.6351 5.83657 11.5387 5.73923 11.5076 5.61518C11.4321 5.31268 11.3126 5.02382 11.1523 4.75649C11.0841 4.6428 11.0861 4.5002 11.1577 4.38856L11.3017 4.16403C11.1129 3.91988 10.8949 3.70204 10.6509 3.51323L10.4262 3.65719C10.3146 3.72862 10.172 3.73067 10.0584 3.6625C9.79112 3.50219 9.50227 3.38264 9.19978 3.30711C9.07559 3.27617 8.9784 3.17965 8.94636 3.05587L8.87534 2.78077C8.57858 2.74424 8.27364 2.74424 7.97687 2.78077L7.90585 3.05587C7.87382 3.17965 7.77662 3.27617 7.65244 3.30711C7.35008 3.38264 7.06109 3.50219 6.79377 3.6625C6.68008 3.7308 6.53763 3.72862 6.42599 3.65719L6.20133 3.51323C5.95719 3.70204 5.73935 3.91988 5.55055 4.16403L5.69451 4.38856C5.76607 4.5002 5.76812 4.6428 5.69996 4.75649C5.53951 5.02382 5.41996 5.31268 5.34458 5.61504C5.3135 5.73923 5.21712 5.83657 5.09321 5.8686L4.81812 5.93963C4.79999 6.08794 4.79072 6.23831 4.79072 6.38881C4.79072 6.53931 4.79985 6.68967 4.81812 6.83799L5.09321 6.90901C5.21712 6.94105 5.3135 7.03824 5.34458 7.16243C5.41996 7.46493 5.53951 7.7538 5.69996 8.02113C5.76812 8.13482 5.76607 8.27727 5.69451 8.38892L5.55055 8.61358C5.73935 8.85773 5.95719 9.07558 6.20133 9.26438L6.42599 9.12043C6.53763 9.04899 6.68008 9.04681 6.79377 9.11511C7.06109 9.27542 7.35008 9.39498 7.65244 9.4705C7.77662 9.50145 7.87382 9.59796 7.90585 9.72188L7.97687 9.9967ZM12.3437 7.1184H12.3441H12.3437Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M8.54626 9.03706C7.15259 9.03706 6.01855 7.90314 6.01855 6.50928C6.01855 5.11543 7.15259 3.98151 8.54626 3.98151C9.94008 3.98151 11.0741 5.11543 11.0741 6.50928C11.0741 7.90314 9.94008 9.03706 8.54626 9.03706ZM8.54626 4.68158C7.53857 4.68158 6.71861 5.50143 6.71861 6.50928C6.71861 7.517 7.53857 8.33699 8.54626 8.33699C9.55409 8.33699 10.3741 7.517 10.3741 6.50928C10.3741 5.50143 9.55409 4.68158 8.54626 4.68158Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M17.2129 13.8518C16.9237 13.8518 16.6346 13.8254 16.3535 13.7732C16.2202 13.7484 16.1133 13.6487 16.0793 13.5173L15.9897 13.1701C15.7332 13.0921 15.4852 12.9897 15.2484 12.8642L14.9617 13.0478C14.8442 13.1232 14.6929 13.1211 14.5774 13.0426C14.0837 12.7071 13.6632 12.2867 13.3277 11.793C13.2492 11.6774 13.2472 11.5262 13.3225 11.4085L13.5063 11.1218C13.3806 10.885 13.2782 10.6371 13.2004 10.3805L12.8531 10.2908C12.7218 10.2569 12.622 10.15 12.5972 10.0167C12.545 9.73571 12.5186 9.44657 12.5186 9.15716C12.5186 8.86788 12.545 8.57874 12.5972 8.29764C12.622 8.16432 12.7218 8.05744 12.8531 8.0235L13.2004 7.9338C13.2782 7.67737 13.3806 7.42927 13.5063 7.19261L13.3225 6.90592C13.2472 6.78828 13.2493 6.63696 13.3277 6.52149C13.6632 6.02773 14.0836 5.60731 14.5774 5.27182C14.6929 5.1933 14.8441 5.19126 14.9617 5.26664L15.2484 5.45027C15.4852 5.32458 15.7332 5.22234 15.9897 5.14436L16.0793 4.79701C16.1133 4.66573 16.2202 4.56594 16.3535 4.54127C16.9155 4.43685 17.5104 4.43685 18.0724 4.54127C18.2057 4.56594 18.3127 4.66573 18.3465 4.79701L18.4363 5.14436C18.6928 5.22234 18.9407 5.32458 19.1775 5.45027L19.4642 5.26664C19.5818 5.19126 19.733 5.1933 19.8486 5.27182C20.3423 5.60718 20.7627 6.02773 21.0981 6.52149C21.1767 6.63696 21.1787 6.78828 21.1033 6.90592L20.9197 7.19261C21.0453 7.42927 21.1476 7.67737 21.2256 7.9338L21.5729 8.0235C21.7042 8.05744 21.804 8.16432 21.8287 8.29764C21.8809 8.57874 21.9074 8.86802 21.9074 9.15716C21.9074 9.44643 21.8809 9.73571 21.8287 10.0167C21.8038 10.15 21.7042 10.2569 21.5729 10.2908L21.2256 10.3805C21.1476 10.6369 21.0453 10.885 20.9197 11.1218L21.1033 11.4085C21.1787 11.5262 21.1767 11.6774 21.0981 11.793C20.7628 12.2867 20.3423 12.7071 19.8486 13.0426C19.733 13.1211 19.5818 13.1232 19.4642 13.0478L19.1775 12.8642C18.9408 12.9897 18.6928 13.0921 18.4363 13.1701L18.3465 13.5173C18.3127 13.6487 18.2057 13.7484 18.0724 13.7732C17.7913 13.8254 17.5022 13.8518 17.2129 13.8518ZM16.6978 13.121C17.0378 13.1648 17.3881 13.1648 17.7281 13.121L17.8109 12.8002C17.843 12.6763 17.9402 12.5799 18.0643 12.5489C18.3972 12.4658 18.7152 12.3342 19.0094 12.1578C19.1231 12.0895 19.2655 12.0916 19.3772 12.1631L19.641 12.3321C19.9223 12.1169 20.1724 11.8667 20.3877 11.5853L20.2187 11.3216C20.1472 11.2099 20.145 11.0674 20.2133 10.9538C20.3897 10.6596 20.5214 10.3415 20.6044 10.0086C20.6355 9.88444 20.7319 9.7871 20.8558 9.7552L21.1765 9.67232C21.1983 9.50233 21.2094 9.32974 21.2094 9.15716C21.2094 8.98457 21.1983 8.81199 21.1765 8.64199L20.8558 8.55911C20.7319 8.52707 20.6354 8.42988 20.6044 8.30569C20.5214 7.97278 20.3899 7.65488 20.2133 7.36056C20.145 7.24687 20.1472 7.10441 20.2187 6.99276L20.3877 6.72898C20.1724 6.44747 19.9224 6.19745 19.641 5.9822L19.3772 6.15124C19.2655 6.22267 19.1231 6.22485 19.0094 6.15669C18.7152 5.98016 18.3972 5.84847 18.0643 5.76545C17.9402 5.7345 17.8428 5.63799 17.8109 5.51407L17.7281 5.19344C17.3881 5.14968 17.0376 5.14968 16.6978 5.19344L16.6149 5.51407C16.5829 5.63799 16.4856 5.7345 16.3615 5.76545C16.0286 5.84847 15.7106 5.98016 15.4163 6.15669C15.3028 6.22485 15.1603 6.22281 15.0485 6.15124L14.7849 5.9822C14.5034 6.19745 14.2534 6.44747 14.0382 6.72898L14.2071 6.99276C14.2786 7.10441 14.2807 7.24687 14.2125 7.36056C14.036 7.65488 13.9045 7.97278 13.8213 8.30569C13.7904 8.42988 13.694 8.52721 13.5701 8.55911L13.2493 8.64199C13.2275 8.81199 13.2165 8.98444 13.2165 9.15716C13.2165 9.32988 13.2275 9.50233 13.2493 9.67232L13.5701 9.7552C13.694 9.78724 13.7904 9.88444 13.8213 10.0086C13.9045 10.3415 14.036 10.6596 14.2125 10.9538C14.2807 11.0674 14.2786 11.21 14.2071 11.3216L14.0382 11.5853C14.2534 11.8668 14.5034 12.1169 14.7849 12.3321L15.0485 12.1631C15.1602 12.0916 15.3028 12.0895 15.4163 12.1578C15.7106 12.3343 16.0286 12.4658 16.3615 12.549C16.4857 12.5799 16.5829 12.6763 16.6149 12.8002L16.6978 13.121ZM21.4856 9.95287H21.4858H21.4856Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M17.2129 11.926C15.6863 11.926 14.4443 10.684 14.4443 9.15737C14.4443 7.63084 15.6863 6.38892 17.2129 6.38892C18.7394 6.38892 19.9814 7.63084 19.9814 9.15737C19.9814 10.6839 18.7394 11.926 17.2129 11.926ZM17.2129 7.07918C16.0669 7.07918 15.1346 8.01143 15.1346 9.15737C15.1346 10.3033 16.0669 11.2356 17.2129 11.2356C18.3588 11.2356 19.2911 10.3033 19.2911 9.15737C19.2911 8.01143 18.3588 7.07918 17.2129 7.07918Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                    </g>
                  </svg>
                  <svg
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0)">
                      <path
                        d="M22.1915 0H18.1415C17.6583 0 17.6583 0.761829 18.1415 0.761829H22.1915C23.3269 0.761829 24.2507 1.69766 24.2507 2.84792V11.6634C24.2507 12.8137 23.327 13.7495 22.1915 13.7495H20.9446C20.8623 13.7495 20.7823 13.7771 20.717 13.8279L18.4289 15.6074V14.1305C18.4289 13.9201 18.2612 13.7495 18.0542 13.7495H13.4947C13.1213 13.7495 12.7624 13.6493 12.4459 13.4588V9.18283C12.4459 8.3819 12.0447 7.67426 11.4355 7.25561V2.84792C11.4355 1.69766 12.3592 0.761829 13.4947 0.761829H18.7444C19.2276 0.761829 19.2276 0 18.7444 0H13.4947C11.9461 0 10.6862 1.27759 10.6862 2.84792V6.92081C10.5147 6.87916 10.3359 6.85646 10.152 6.85646H3.29387C2.02905 6.85646 1 7.90006 1 9.18283V13.0054C1 13.4967 1.74927 13.4967 1.74927 13.0054V9.18283C1.74927 8.32014 2.44215 7.61829 3.29387 7.61829H10.1521C11.0038 7.61829 11.6967 8.32014 11.6967 9.18283V13.6105C11.6922 13.6441 11.6924 13.678 11.6967 13.7113V16.1346C11.6967 16.1825 11.6939 16.2302 11.6896 16.2776H10.917C10.0657 16.2776 9.35599 16.9023 9.20883 17.7234C9.17476 17.7365 9.14205 17.7547 9.11172 17.7785L7.4361 19.094V18.08C7.4361 17.8697 7.26841 17.6991 7.06147 17.6991H3.29387C2.44215 17.6991 1.74927 16.9973 1.74927 16.1346V12.2908C1.74927 11.7995 1 11.7995 1 12.2908V16.1346C1 17.4174 2.02905 18.461 3.29387 18.461H6.68688V19.8694C6.68688 20.1749 7.05177 20.3582 7.29049 20.1709L9.18041 18.6872V22.9725C9.18041 23.9438 9.9595 24.734 10.9171 24.734H13.2161V25.6228C13.2161 25.9283 13.581 26.1118 13.8197 25.9244L15.336 24.734H15.7839C16.7415 24.734 17.5206 23.9438 17.5206 22.9725V22.2962C17.5206 21.8049 16.7713 21.8049 16.7713 22.2962V22.9725C16.7713 23.5238 16.3284 23.9722 15.7839 23.9722H15.2082C15.1253 23.9722 15.0448 24.0001 14.9792 24.0515L13.9653 24.8475V24.353C13.9653 24.1427 13.7976 23.9721 13.5907 23.9721H10.917C10.3726 23.9721 9.92963 23.5237 9.92963 22.9724V18.0391C9.92963 17.4879 10.3726 17.0395 10.917 17.0395H15.7839C16.3284 17.0395 16.7713 17.4879 16.7713 18.0391V22.9091C16.7713 23.4005 17.5206 23.4005 17.5206 22.9091V18.0392C17.5206 17.0679 16.7415 16.2777 15.7839 16.2777H12.4417C12.4445 16.2301 12.446 14.3062 12.446 14.3062C12.7763 14.4412 13.1305 14.5114 13.4947 14.5114H17.6797V16.3784C17.6797 16.6832 18.043 16.8667 18.2819 16.681L21.0715 14.5114H22.1916C23.7401 14.5114 25 13.2338 25 11.6634V2.84792C25 1.27759 23.7401 0 22.1915 0Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M18.7792 2.81431C18.3035 2.69084 17.8188 3.07297 17.8188 3.57273C17.8188 4.11876 17.6231 4.64498 17.268 5.05419L16.2358 6.24178C16.1689 6.13751 16.0534 6.06849 15.9219 6.06849H13.9069C13.6999 6.06849 13.5322 6.23903 13.5322 6.4494V11.0592C13.5322 11.2696 13.6999 11.4401 13.9069 11.4401H15.9219C16.0733 11.4401 16.2034 11.3487 16.2625 11.2173C16.6704 11.4708 17.1432 11.6078 17.6242 11.6078H21.1853C21.7295 11.6078 22.1784 11.1277 22.1529 10.5758C22.1415 10.3314 22.1539 7.04982 22.1539 6.97694C22.1539 6.43391 21.7194 5.99205 21.1864 5.99205L19.3345 5.98641L19.4112 5.80179C19.7616 4.95804 19.7039 3.97965 19.2571 3.18445C19.1528 2.99867 18.983 2.86728 18.7792 2.81431C18.5753 2.76139 18.983 2.86728 18.7792 2.81431C18.3035 2.69084 18.983 2.86728 18.7792 2.81431ZM15.5473 10.6783H14.2815V6.83031H15.5473V10.6783ZM21.1853 6.75383C21.3063 6.75383 21.4047 6.85388 21.4047 6.97689C21.4047 7.04937 21.4039 7.24607 21.4029 7.51276C21.3974 8.98522 21.3937 10.3798 21.4044 10.6116C21.4083 10.6952 21.3683 10.751 21.3441 10.7768C21.3022 10.8214 21.2458 10.8459 21.1853 10.8459H17.6242C17.1997 10.8459 16.7842 10.6963 16.4542 10.4248L16.2965 10.295V7.32225L17.8296 5.55842C18.3058 5.0097 18.568 4.3045 18.568 3.57268C18.568 3.55115 18.597 3.54556 18.6066 3.56232C18.9383 4.15264 18.9811 4.87897 18.721 5.50534L18.4253 6.21735C18.3765 6.33482 18.3888 6.46926 18.4579 6.57561C18.5271 6.68196 18.644 6.74606 18.7693 6.74646L21.1853 6.75383Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M4.20789 13.2303C4.00094 13.2303 3.83325 13.4009 3.83325 13.6112C3.83325 13.8216 4.00094 13.9921 4.20789 13.9921H5.31222L5.10592 15.2608C5.07215 15.4683 5.21032 15.6644 5.41442 15.6987C5.43515 15.7022 5.45568 15.7039 5.47596 15.7039C5.65598 15.7039 5.81478 15.5716 5.84515 15.3851L6.07163 13.9922H6.9754L6.7691 15.2608C6.73533 15.4684 6.8735 15.6644 7.0776 15.6988C7.09833 15.7023 7.11886 15.704 7.13914 15.704C7.31917 15.704 7.47796 15.5717 7.50833 15.3851L7.73481 13.9922H9.23801C9.44495 13.9922 9.61264 13.8217 9.61264 13.6113C9.61264 13.401 9.44495 13.2304 9.23801 13.2304H7.85869L8.0098 12.3012H9.23801C9.44495 12.3012 9.61264 12.1306 9.61264 11.9203C9.61264 11.7099 9.44495 11.5394 9.23801 11.5394H8.13368L8.33998 10.2707C8.37374 10.0632 8.23558 9.86709 8.03148 9.83275C7.82712 9.79832 7.63451 9.9389 7.60074 10.1464L7.37426 11.5393H6.47049L6.67679 10.2707C6.71056 10.0631 6.57239 9.86704 6.36829 9.8327C6.16369 9.79827 5.97138 9.93885 5.93756 10.1464L5.71108 11.5392H4.20789C4.00094 11.5392 3.83325 11.7098 3.83325 11.9202C3.83325 12.1305 4.00094 12.3011 4.20789 12.3011H5.5872L5.4361 13.2303H4.20789ZM6.34666 12.3011H7.25043L7.09933 13.2303H6.19556L6.34666 12.3011Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M13.3461 19.0049C13.0436 18.7516 12.6411 18.6517 12.2374 18.7515C11.72 18.8793 11.198 19.371 11.198 20.1815C11.198 20.686 11.3791 21.1239 11.7516 21.5203C12.0558 21.8441 12.4949 22.1519 13.1751 22.5186C13.23 22.5483 13.2903 22.563 13.3506 22.563C13.4109 22.563 13.4712 22.5483 13.5261 22.5186C14.7128 21.879 15.5032 21.2367 15.5032 20.1815C15.5032 19.3666 14.9626 18.8799 14.4268 18.7591C14.0243 18.6682 13.6341 18.7646 13.3461 19.0049ZM14.7539 20.1815C14.7539 20.7507 14.3826 21.1716 13.3506 21.7492C12.3186 21.1715 11.9472 20.7506 11.9472 20.1815C11.9472 19.7581 12.1884 19.5476 12.4141 19.4918C12.4557 19.4816 12.5003 19.4758 12.5461 19.4758C12.7159 19.4758 12.9025 19.5555 13.0176 19.7824C13.0832 19.9115 13.2158 19.9915 13.358 19.9886C13.5008 19.9857 13.6296 19.9004 13.69 19.7688C13.8113 19.5046 14.0662 19.4581 14.2644 19.5029C14.5011 19.5561 14.7539 19.7625 14.7539 20.1815Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                    </g>
                  </svg>
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.25 10.4004C2.25 5.9064 5.9064 2.25 10.4004 2.25C14.7757 2.25 18.3568 5.71629 18.5426 10.0467L18.5504 10.2284L18.7256 10.2769C21.6649 11.0914 23.75 13.795 23.75 16.8887C23.75 18.124 23.4211 19.3247 22.7963 20.3797L22.7421 20.4712L23.6104 23.6104L20.4712 22.7421L20.3797 22.7963C19.3247 23.4211 18.124 23.75 16.8887 23.75C13.7948 23.75 11.091 21.6648 10.2768 18.7253L10.2282 18.5501L10.0466 18.5423C8.70632 18.4845 7.4083 18.1011 6.25779 17.4207L6.16632 17.3666L2.38945 18.4112L3.43414 14.6345L3.38005 14.543C2.6399 13.2913 2.25 11.8654 2.25 10.4004ZM10.4004 3.03906C6.34109 3.03906 3.03906 6.34109 3.03906 10.4004C3.03906 11.8088 3.43815 13.178 4.19327 14.3594L4.28799 14.5076L3.52113 17.2797L6.2932 16.5128L6.44138 16.6075C7.62296 17.3626 8.99201 17.7617 10.4004 17.7617C14.4597 17.7617 17.7617 14.4597 17.7617 10.4004C17.7617 6.34109 14.4597 3.03906 10.4004 3.03906ZM18.8243 11.1317L18.5317 11.0334L18.4964 11.3401C18.0645 15.0843 15.0843 18.0645 11.3402 18.4962L11.0336 18.5315L11.1319 18.8241C11.9504 21.2616 14.2597 22.9609 16.8887 22.9609C18.0659 22.9609 19.2088 22.6232 20.1923 21.9842L20.3411 21.8874L22.4789 22.4789L21.8874 20.3411L21.9843 20.1921C22.6233 19.2086 22.9609 18.0659 22.9609 16.8887C22.9609 14.2597 21.2616 11.9504 18.8243 11.1317Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M10 14H11V15H10V14Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                      <path
                        d="M11.75 8.38411C11.75 8.72263 11.6055 9.03508 11.3431 9.26402L9.875 10.5455V12H11.125V11.0704L12.187 10.1435C12.7036 9.69257 13 9.05138 13 8.38411C13 7.06943 11.8786 6 10.5 6C9.12142 6 8 7.06943 8 8.38411H9.25C9.25 7.72677 9.81071 7.19205 10.5 7.19205C11.1893 7.19205 11.75 7.72677 11.75 8.38411Z"
                        fill={iconColor === "" ? "#BDFF00" : iconColor}
                      />
                    </g>
                  </svg>
                </div>
              </div>
              <div
                className="background-mobile"
                style={{
                  background:
                    backgroundColor === "" ? backgroundColor : backgroundColor,
                }}
              />
            </div>
            <div className="edit-screen w-75 ml-4">
              <div className="mr-3">
                <label className="text-grey-6 f-16 d-block mb-1">
                  Header Background<span className="text-danger">*</span>
                </label>
                <label className="custom-file-upload w-50 position-relative d-flex align-items-center justify-content-center mb-0" title={header}>
                  <input
                    className="d-none"
                    type="file"
                    accept="image/png"
                    onClick={(e) => (e.target.value = null)}
                    onChange={(e) => handleChange(e, "header")}
                  />
                  <div className="width-50">
                    {header !== "" ? (
                      <img src={SvgIcon} alt="svg-icon" />
                    ) : (
                      <span>Click to browse</span>
                    )}
                    {header !== "" && (
                      <p className="text-white mb-0 mt-1 col-12 text-truncate m-auto">
                        {header}
                      </p>
                    )}
                    {header !== "" && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setHeader("");
                          setPngSrc("");
                        }}
                        className="remove-button"
                      >
                        <p className="text-uppercase mb-0 text-white">Remove</p>
                      </div>
                    )}
                  </div>
                </label>
                {ImgError && <p className="text-danger f-12">{ImgError}</p>}
              </div>
              <div className="mt-4">
                <label className="text-grey-6 f-16 d-block mb-1">
                  Theme Icon<span className="text-danger">*</span>
                </label>
                <div className="d-flex justify-content-between">
                  <div className="text-center w-50" title={ImgName}>
                    <label className="custom-file-upload w-100 position-relative d-flex align-items-center justify-content-center mb-0">
                      <input
                        className="d-none"
                        type="file"
                        accept="image/svg+xml"
                        onClick={(e) => (e.target.value = null)}
                        onChange={(e) => handleChange(e, "svg-theme-icon")}
                      />
                      <div className="width-50">
                        {base64String !== "" ? (
                          <img src={base64String} alt="svg-icon" />
                        ) : (
                          <span>Click to browse</span>
                        )}
                        {base64String !== "" && (
                          <p className="text-white mb-0 mt-1 col-12 text-truncate m-auto">
                            {ImgName}
                          </p>
                        )}
                        {base64String !== "" && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setSvgName("");
                              setBase64String("");
                            }}
                            className="remove-button"
                          >
                            <p className="text-uppercase mb-0 text-white">
                              Remove
                            </p>
                          </div>
                        )}
                      </div>
                    </label>
                    {SVGError && (
                      <p className="text-danger f-12 m-0 text-left">
                        {SVGError}
                      </p>
                    )}
                    <span style={{ color: "#A0A0A0" }} className="f-12">
                      Upload SVG
                    </span>
                  </div>
                  {/* <div className="text-center w-50 ml-3" title={PdfName}>
                    <label className="custom-file-upload w-100 position-relative d-flex align-items-center justify-content-center mb-0">
                      <input
                        className="d-none"
                        type="file"
                        accept="application/pdf"
                        onClick={(e) => (e.target.value = null)}
                        onChange={(e) => handleChange(e, "pdf-theme-icon")}
                      />
                      <div className="width-50">
                        {PdfName !== "" ? (
                          <img src={PdfIcon} alt="svg-icon" />
                        ) : (
                          <span>Click to browse</span>
                        )}
                        {PdfName !== "" && (
                          <p className="text-white mb-0 mt-1 col-12 text-truncate m-auto">
                            {PdfName}
                          </p>
                        )}
                        {PdfName !== "" && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setPdfName("");
                              setPdfSrc("");
                            }}
                            className="remove-button"
                          >
                            <p className="text-uppercase mb-0 text-white">
                              Remove
                            </p>
                          </div>
                        )}
                      </div>
                    </label>
                    {PDFError && (
                      <p className="text-danger f-12 m-0 text-left">
                        {PDFError}
                      </p>
                    )}
                    <span style={{ color: "#A0A0A0" }} className="f-12">
                      Upload PDF for iOS
                    </span>
                  </div> */}
                </div>
              </div>
              <div className="mt-4">
                <div className="d-flex">
                  <div className="w-50">
                    <label className="text-grey-6 f-16 d-block mb-1">
                      Theme Title<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter theme title"
                      className="w-100"
                      onChange={(e) => setTitle(e.target.value)}
                      value={title}
                    />
                  </div>
                  <div className="w-50 ml-3 position-relative">
                    <label className="text-grey-6 f-16 d-block mb-1">
                      Text Color<span className="text-danger">*</span>
                    </label>
                    <input
                      style={{ background: `url(${colorPicker})` }}
                      type="text"
                      placeholder="Select or Enter text color"
                      className="w-100 color-picker"
                      onClick={() => setShowTextPicker(!ShowTextPicker)}
                      value={textColor === "" ? textColor : textColor}
                    />
                    {ShowTextPicker && (
                      <div className="position-absolute color-picker-wrap">
                        <SketchPicker
                          color={textColor}
                          onChange={(e) => setTextColor(e.hex)}
                        />
                        <div
                          onClick={() => setShowTextPicker(!ShowTextPicker)}
                          className="overlay position-fixed"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <div className="d-flex">
                  <div className="w-50 position-relative">
                    <label className="text-grey-6 f-16 d-block mb-1">
                      Card Color<span className="text-danger">*</span>
                    </label>
                    <input
                      style={{ background: `url(${colorPicker})` }}
                      type="text"
                      placeholder="Select or Enter text color"
                      className="w-100 color-picker"
                      onClick={() => setShowCardPicker(!ShowCardPicker)}
                      value={cardColor === "" ? cardColor : cardColor}
                    />
                    {ShowCardPicker && (
                      <div className="position-absolute color-picker-wrap">
                        <div
                          onClick={() => setShowCardPicker(!ShowCardPicker)}
                          className="overlay position-fixed"
                        />
                        <SketchPicker
                          color={cardColor}
                          onChange={(e) => setCardColor(e.hex)}
                        />
                      </div>
                    )}
                  </div>
                  <div className="w-50 ml-3 position-relative">
                    <label className="text-grey-6 f-16 d-block mb-1">
                      Primary Color<span className="text-danger">*</span>
                    </label>
                    <input
                      style={{ background: `url(${colorPicker})` }}
                      type="text"
                      placeholder="Select or Enter text color"
                      className="w-100 color-picker"
                      onClick={() => setShowPrimaryPicker(!ShowPrimaryPicker)}
                      value={primaryColor === "" ? primaryColor : primaryColor}
                    />
                    {ShowPrimaryPicker && (
                      <div className="position-absolute color-picker-wrap">
                        <div
                          onClick={() =>
                            setShowPrimaryPicker(!ShowPrimaryPicker)
                          }
                          className="overlay position-fixed"
                        />
                        <SketchPicker
                          color={primaryColor}
                          onChange={(e) => setPrimaryColor(e.hex)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <div className="d-flex">
                  <div className="w-50 position-relative">
                    <label className="text-grey-6 f-16 d-block mb-1">
                      Background Color<span className="text-danger">*</span>
                    </label>
                    <input
                      style={{ background: `url(${colorPicker})` }}
                      type="text"
                      placeholder="Select or Enter text color"
                      className="w-100 color-picker"
                      onClick={() =>
                        setShowBackgroundPicker(!ShowBackgroundPicker)
                      }
                      value={
                        backgroundColor === ""
                          ? backgroundColor
                          : backgroundColor
                      }
                    />
                    {ShowBackgroundPicker && (
                      <div className="position-absolute color-picker-wrap">
                        <div
                          onClick={() =>
                            setShowBackgroundPicker(!ShowBackgroundPicker)
                          }
                          className="overlay position-fixed"
                        />
                        <SketchPicker
                          color={backgroundColor}
                          onChange={(e) => setBackgroundColor(e.hex)}
                        />
                      </div>
                    )}
                  </div>
                  <div className="w-50 ml-3 position-relative">
                    <label className="text-grey-6 f-16 d-block mb-1">
                      Icon Color<span className="text-danger">*</span>
                    </label>
                    <input
                      style={{ background: `url(${colorPicker})` }}
                      type="text"
                      placeholder="Select or Enter text color"
                      className="w-100 color-picker"
                      onClick={() => setShowIconPicker(!ShowIconPicker)}
                      value={iconColor.hex === "" ? iconColor : iconColor}
                    />
                    {ShowIconPicker && (
                      <div className="position-absolute color-picker-wrap">
                        <div
                          onClick={() => setShowIconPicker(!ShowIconPicker)}
                          className="overlay position-fixed"
                        />
                        <SketchPicker
                          color={iconColor}
                          onChange={(e) => setIconColor(e.hex)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-4 d-flex justify-content-between">
                <button
                  // disabled={
                  //   !(
                  //     header ||
                  //     ImgName ||
                  //     PdfName ||
                  //     title ||
                  //     textColor ||
                  //     cardColor ||
                  //     primaryColor ||
                  //     backgroundColor ||
                  //     iconColor
                  //   )
                  // }
                  onClick={() => props.history.push("/dashboard/themes")}
                  className="text-green form-button pl-5 pr-5 pt-1 pb-1"
                >
                  Cancel
                </button>
                <button
                  disabled={
                    !(
                      header &&
                      base64String &&
                      title &&
                      textColor &&
                      cardColor &&
                      primaryColor &&
                      backgroundColor &&
                      iconColor
                    )
                  }
                  className="text-green form-button pl-5 pr-5 pt-1 pb-1"
                  onClick={(e) =>
                    handleModal(
                      e,
                      props.location.pathname.split("/")[3] === "edit-theme"
                        ? "update"
                        : "add",
                      "theme"
                    )
                  }
                >
                  {props.location.pathname.split("/")[3] === "edit-theme"
                    ? "Update"
                    : "Add"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <Style />
        {OpenModal && (
          <Modal
            Name={Name}
            Type={OpenModal}
            Close={(e, type) => CloseModal(e, type)}
          />
        )}
      </div>
    </>
  );
}

const mapStateToProps = ({ ThemeListReducer }) => {
  const { loading, add_data, data, edit_data, delete_data } = ThemeListReducer;
  return { loading, add_data, data, edit_data, delete_data };
};

const mapDispatchToProps = {
  AddTheme,
  EditTheme,
  deleteTheme,
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Theme));
